import React from 'react';
import { Button } from 'antd';
import { TEMPLATE_FORM_CONSTANTS } from '../constants';
import { SidebarPanel, SidebarTitle, ButtonGroup } from '../styles';

interface QuickInsertButtonsProps {
  onInsertButton: () => void;
  onInsertDivider: () => void;
  onInsertSpacer: () => void;
  onInsertSocialLinks: () => void;
}

const QuickInsertButtons: React.FC<QuickInsertButtonsProps> = ({
  onInsertButton,
  onInsertDivider,
  onInsertSpacer,
  onInsertSocialLinks,
}) => {
  return (
    <SidebarPanel>
      <SidebarTitle>{TEMPLATE_FORM_CONSTANTS.MESSAGES.QUICK_INSERT}</SidebarTitle>
      <ButtonGroup>
        <Button size="small" onClick={onInsertButton}>
          🔘 {TEMPLATE_FORM_CONSTANTS.BUTTONS.CTA_BUTTON}
        </Button>
        <Button size="small" onClick={onInsertDivider}>
          ➖ {TEMPLATE_FORM_CONSTANTS.BUTTONS.DIVIDER}
        </Button>
        <Button size="small" onClick={onInsertSpacer}>
          📏 {TEMPLATE_FORM_CONSTANTS.BUTTONS.SPACER}
        </Button>
        <Button size="small" onClick={onInsertSocialLinks}>
          📱 {TEMPLATE_FORM_CONSTANTS.BUTTONS.SOCIAL_LINKS}
        </Button>
      </ButtonGroup>
    </SidebarPanel>
  );
};

export default QuickInsertButtons;
